<template>
 <v-dialog v-model="dialogAccount" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
  <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">assignment_ind</v-icon>&nbsp;&nbsp;{{$t('Dialog.account')}}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="padding-left: 30px;">
    <v-progress-linear :indeterminate="progress" v-if="status == 'progress'"></v-progress-linear>
      <v-container wrap style="padding-top:  0px;" v-else>
            <v-layout align-center justify-center wrap>
              <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center; height: 9vh;">
            <v-text-field append-icon="search" :label="$t('LeftSide.addFiend.searching')" solo clearable v-model="search"  class="bgsearchcontact CSChatThai" id="searchcontact" style="height: 8vh;"></v-text-field>
            <br/>
          </v-flex>
            <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;">
            <v-container style="height: 30vh; margin-top: 0; width: 80%;padding: 0;" class="scroll-y CSChatThai" v-if="FilterFriendList.length != 0">
              <v-layout align-center justify-center>
                <v-list two-line class="scroll-y CSChatThai" style="width: 100%;">
                  <v-radio-group v-model="contact_select" column>
                  <template v-for="(item, index) in FilterFriendList" >
                    <v-list-tile avatar ripple >
                      <v-list-tile-action>
                        <v-radio  :value="item"></v-radio>
                      </v-list-tile-action>
                      <v-list-tile-avatar >
                        <img v-if="item.profilepicture"  :src="item.profilepicture" class="alligator-turtle">
                        <img  v-else-if="item.type === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                        <img  v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                        <img  v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                        <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.name }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-radio-group>
                </v-list>
              </v-layout>
            </v-container>
            </v-flex>
            </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions >
      <v-spacer></v-spacer>
      <v-layout align-center justify-center wrap >
      <v-btn color="red" flat @click.native="closeDialog" class="CSChatThai" style="text-transform: none;">{{$t('AnswerQuestion.cancel')}}</v-btn>
      <v-btn color="blue darken-1" flat @click="sendContact()" class="CSChatThai" style="text-transform: none;">{{$t('AnswerQuestion.send')}}</v-btn>
    </v-layout>
    </v-card-actions>
</v-card>
</v-dialog>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

export default {
  props: {dialogAccount: false},
  data: () => ({
    token: '',
    progress: false,
    status: 'progress',
    FriendList: [],
    search: '',
    contact_select: '',
    typeuser: ''
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.typeuser = localStorage.getItem('type_user')
    this.getlistfriend()
  },
  watch: {
    socketaccept_friend () {
      this.getlistfriend()
    },
    socketremove_friend () {
      this.getlistfriend()
    }
  },
  computed: {
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    },
    ...sync('*')
  },
  methods: {
    closeDialog () {
      this.$emit('closeAccount', false)
      this.contact_select = ''
      this.search = ''
    },
    sendContact () {
      if (this.contact_select !== '') {
        this.axios.post(process.env.APIimage + '/push_contact', {tokenroom: this.$route.params.roomid, tokenuser: this.token, tokencontact: this.contact_select['tokenuser'], type: this.typeuser}).then((response) => {
          if (response.data['status'] === 'success') {
            this.$emit('pushcontact', {data: response.data.data, status: 'success'})
            this.$swal(
              '',
              this.$t('Alert.Success.account'),
              'success'
            )
            this.closeDialog()
          } else {
            this.$swal(
              '',
              this.$t('Alert.Fail.default.somethingWrong'),
              'error'
            )
            this.closeDialog()
          }
        }, () => {
          // console.log(this.contact_select)
          this.$emit('pushcontact', {data: this.contact_select, status: 'error'})
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
          this.closeDialog()
        })
      }
    },
    getlistfriend () {
      this.status = 'progress'
      this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
        this.status = 'show'
        this.FriendList = response.data['listfriend']
      })
    }
  }
}
</script>
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_chat/AccountDialog.vue